<template>
  <header :class="[ 'c-topbar', `c-topbar--${appSlug}`, 'u-py' ]">
    <div class="c-topbar__logo u-px">
      <router-link :to="{ name: 'Overview' }" class="c-topbar__logo-link">
        <img class="c-topbar__logo-img" v-if="logo" :src="logo" :alt="name" />
        <span v-else>Teacher Tool</span>
        <span class="c-topbar__level" v-if="level">{{level}}</span>
      </router-link>
    </div>
    <components :is="currentNav" />
    <FHButton
      v-if="isTeacher && $store.state.appConfig.beta"
      class="c-topbar__feedback-btn"
      target="_blank"
      :href="$store.state.appConfig.beta"
    >
      <i class="app-icon-feedback_icon" />
      <span v-html="$t('NAV_GIVE_FEEDBACK')" />
    </FHButton>

    <LanguageSelect v-if="!isTeacher && langs && langs.length > 1" :langs="langs" />

    <User v-if="isTeacher" />
  </header>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import { mapGetters } from 'vuex'
import Nav from '@/components/Nav'
import LanguageSelect from '@/components/LanguageSelect'
import User from '@/components/User'
import FHButton from '@forlagshuset/v-button'

const DEFAULT_NAV = 'NavDefault'

export default {
  name: 'TopBarDefault',

  components: {
    Nav,
    LanguageSelect,
    User,
    FHButton
  },

  computed: {
    ...mapGetters({
      logo: 'appConfig/getAppLogo',
      name: 'appConfig/getAppName',
      langs: 'appConfig/getAppLangs',
    })
  },

  setup(props, ctx) {
    const appSlug = computed(() => ctx.root.$store.state.appConfig.slug)
    const appLayoutNav = computed(() => ctx.root.$store.getters['appConfig/getAppLayoutNav'] || DEFAULT_NAV)
    const currentNav = ref(null)
    const userdata = computed(() => ctx.root.$store.state.user.user)
    const level = computed(() => ctx.root.$store.state.appConfig.level)
    const isTeacher = computed(() => ctx.root.$store.getters['appConfig/isTeacher'])

    watch(appLayoutNav, layout => {
      currentNav.value = () => import(`../Nav/${layout}`)
    })

    const logout = () => {
      ctx.root.$store.dispatch('user/logoutUser')
    }

    return {
      appSlug,
      appLayoutNav,
      currentNav,
      logout,
      userdata,
      level,
      isTeacher
    }
  }
}
</script>
